import { LuShare2 } from "react-icons/lu";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useEnhancedToast } from "@/hooks/use-enhanced-toast";

interface HomeCycleShareButtonProps {
  shareUrl: string | null;
  isAdmin?: boolean;
  onOpenShare?: () => void;
}

export function HomeCycleShareButton({
  shareUrl,
  isAdmin,
  onOpenShare,
}: HomeCycleShareButtonProps) {
  const { t } = useTranslation();
  const { error } = useEnhancedToast();

  const handleClick = () => {
    if (!shareUrl) {
      error({
        title: t("v2.home.shareUnavailable"),
        description: t("v2.home.shareUnavailableDesc"),
      });
      return;
    }

    if (isAdmin && onOpenShare) {
      onOpenShare();
      return;
    }

    error({
      title: t("v2.home.shareNotReady"),
      description: t("v2.home.shareNotReadyDesc"),
    });
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="h-9 w-9 shrink-0 rounded-full text-muted-foreground hover:bg-muted/60 hover:text-foreground"
      onClick={handleClick}
      aria-label={t("v2.home.shareCycle")}
    >
      <LuShare2 className="h-[18px] w-[18px] stroke-[1.75]" />
    </Button>
  );
}
